import React, {Component, createRef} from 'react';
import {gsap} from 'gsap';
import './Scene8.css';
import WaveContainer from '../WaveContainer';
import c1 from '../../Resources/Celu1.png';
import c2 from '../../Resources/Celu2.png';
import c3 from '../../Resources/Celu3.gif';
import c4 from '../../Resources/Celu4.png';
import c5 from '../../Resources/Celu5.png';
import BgGrid from "../BgGrid";

const scene8 = createRef();
const pinPhone = createRef();
const mainPhone = createRef();
const phoneContainer = createRef();

class Scene8 extends Component<> {
    componentDidMount() {
        gsap.timeline({
            scrollTrigger: {
                trigger: '#s8bg',
                start: 'top 75%',
                end: 'top 25%',
                scrub: true,
                toggleActions: 'play complete restart reverse',
            }
        }).from(['#s8bg6V', '#s8bg1V', '#s8bg5V', '#s8bg2V', '#s8bg4V', '#s8bg3V'],{
            attr:{y1: 143, y2: 143},
            stagger: .3,
            duration: 2,
        }).from(['#s8bg1H','#s8bg2H','#s8bg3H','#s8bg4H','#s8bg0H'],{
            attr:{x1: 450, x2: 550},
            stagger: .2,
            duration: 2,
        }, '0');

        gsap.timeline({
            scrollTrigger: {
                trigger: phoneContainer.current,
                start: 'top top',
                endTrigger: '#s9',
                end: 'bottom 20%',
                scrub: true,
                pin: pinPhone.current,
                immediateRender: false,
            }
        }).to(mainPhone.current, {
            duration: 8,
            width: '18vw',
            opacity: 1,
        }).to('#bpa', {
            duration: 3,
            marginTop: '-80vh',
        });
    }

    render() {
        return (
            <section ref={scene8} className={"s8-container bg2"}>
                <div className='content'>
                    <WaveContainer wid="wave2" fill='#FFFFFF' speed= {0.25} points= {6}>
                        <div ref={phoneContainer} className={"s8-phones-container"}>
                            <div className={"small-phone outer-phones"}>
                                <img className={"s8-phone accessibility-img"} src={c1} alt="1"/>
                            </div>
                            <div className={"small-phone middle-phones"}>
                                <img className={"s8-phone accessibility-img"} src={c2} alt="2"/>
                            </div>
                            <div className={"big-phone-area"}>
                            </div>
                            <div className={"small-phone middle-phones"}>
                                <img className={"s8-phone accessibility-img"} src={c4} alt="4"/>
                            </div>
                            <div className={"small-phone outer-phones"}>
                                <img className={"s8-phone accessibility-img"} src={c5} alt="5"/>
                            </div>
                        </div>
                        <div ref={pinPhone} className={'pin-section'}>
                            <BgGrid id='s8bg' hLines={7} stroke={'#888888'}
                                shapes={[{id: 's8rc', shape: '+', x:2, y:4, size:6, color:"red"},
                                    {id: 's8oc', shape: '+', x:6, y:1, size:6, color:"orange"},
                            ]}/>
                            <div id={'bpa'} className={'big-phone-area'}>
                                <img ref={mainPhone} className={"s8-big-phone accessibility-img"} src={c3} alt="3"/>
                            </div>
                        </div>
                    </WaveContainer>
                </div>
            </section>
        )
    }
}

export default Scene8;
